import { Trans, useLingui } from '@lingui/react/macro'

import ConfirmDialog from '@/components/ui/ConfirmDialog'
import { useMutation } from '@apollo/client'
import useOrganization from '../hooks/useOrganization'
import Button from '@/components/ui/Button'
import { AdminAPI } from '@guestgoodie/graphql'

export function OrganizationSettings() {
  const { t } = useLingui()
  const { organization } = useOrganization()

  const [deleteOrg, { loading }] = useMutation(AdminAPI.organization.DELETE)

  const [resetOrg, { loading: loadingReset }] = useMutation(
    AdminAPI.organization.RESET,
    {
      onCompleted() {
        // Let's just completely reload to make sure we reload all data.
        window.location.reload()
      }
    }
  )

  const orgName = organization.name

  return (
    <div className="flex flex-col gap-4">
      {organization.deleted && (
        <div className="flex flex-row justify-center items-center p-4">
          <span className="text-regular text-text-light">
            <Trans>There are no other settings for you currently.</Trans>
          </span>
        </div>
      )}
      {!organization.deleted && (
        <div className="relative border border-red-300 rounded py-7 px-5">
          <div className="flex flex-row items-center justify-center gap-2 absolute top-0 left-0 w-full -translate-y-1/2">
            <span className="text-text-light bg-white px-2">
              <Trans>Danger Zone</Trans>
            </span>
          </div>
          <div className="flex flex-row justify-between gap-2">
            <ConfirmDialog
              title={t`Reset Organization`}
              message={t`Are your sure that you want to reset the organization with the name \"${orgName}\"? All Goodies, Categories, Promotions, Files and anything else shown in your guest app will be deleted. This can not be reversed.`}
              onConfirm={resetOrg}
              asChild
              needsConfirmInput
              confirmInputText={t`reset permanently`}
            >
              <Button
                type="button"
                loading={loadingReset}
                variant="outline"
                className="bg-red-500 border-red-500"
              >
                <Trans>Reset</Trans>
              </Button>
            </ConfirmDialog>
            <ConfirmDialog
              title={t`Delete Organization`}
              message={t`Are your sure that you want to delete the organization with the name \"${orgName}\"? You can reverse it for 3 months by writing our support.`}
              onConfirm={deleteOrg}
              asChild
            >
              <Button
                type="button"
                loading={loading}
                className="bg-red-500 border-red-500"
              >
                <Trans>Delete Organization</Trans>
              </Button>
            </ConfirmDialog>
          </div>
        </div>
      )}
    </div>
  )
}
